import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B3CFE5",
  fillRule: "evenodd",
  d: "M10.968 12.002v.002l-.001.001c-.143.42-.214.864-.214 1.33 0 .504.089.957.277 1.351l.001.004.002.004c.189.368.43.683.724.94l.004.004.004.003c.298.245.627.427.983.546a3.29 3.29 0 0 0 1.045.176c.41 0 .8-.078 1.167-.234h.002l.001-.001c.369-.162.692-.38.966-.653.282-.274.505-.593.668-.955v-.001l.001-.002c.166-.376.248-.775.248-1.194 0-.419-.082-.815-.249-1.185a2.93 2.93 0 0 0-.67-.944 2.972 2.972 0 0 0-.97-.641 3.028 3.028 0 0 0-.715-.2l.19-.143c.252-.187.512-.374.78-.56.27-.19.525-.365.762-.529l.276-.19-.213-.259a97.624 97.624 0 0 0-.355-.428 20.044 20.044 0 0 0-.347-.433l-.182-.222-1.01.72c-.293.21-.595.445-.904.704-.304.253-.603.532-.897.834a6.956 6.956 0 0 0-.799.992v.001a5.354 5.354 0 0 0-.575 1.162Zm4.02 1.838.003-.005a1.18 1.18 0 0 0 .107-.5 1.18 1.18 0 0 0-.107-.5l-.003-.004-.002-.005a1.278 1.278 0 0 0-.696-.696 1.308 1.308 0 0 0-1.004 0c-.15.065-.279.155-.389.272-.113.12-.203.26-.272.424-.066.158-.1.327-.1.51 0 .182.034.35.1.509a1.34 1.34 0 0 0 .668.712c.146.062.308.095.488.095s.348-.033.505-.097c.162-.075.303-.173.422-.293.119-.118.211-.257.278-.417l.002-.005Z",
  clipRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#B3CFE5",
  d: "M7.077 7.538V9.25h.788v7.016h1.76V7.538H7.077Z"
});
function CounterChartColor(_ref) {
  let {
    color = colors.actionMinor[500],
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9.25",
    stroke: color,
    strokeWidth: "1.5"
  }), _ref2, _ref3);
}
export default CounterChartColor;